const URL = '/precios';

const state = {
  all: [],
  selected: {
    id: null,
    vigencia: null,
    periodo: null,
    pleno: null,
    subsidio: null,
    usuario: null,
    detalle: null,
    created_at: null,
    updated_at: null
  },
  edited: {
    id: null,
    vigencia: null,
    periodo: null,
    pleno: null,
    subsidio: null,
    usuario: null,
    detalle: null,
    created_at: null,
    updated_at: null
  },
  filters: {
    vigencia_from: null,
    vigencia_to: null,
  },
  loading: false,
  headers: [
    {
      text: 'Vigencia',
      value: 'vigencia',
      align: 'center'
    },
    {
      text: 'Pleno',
      value: 'pleno',
      align: 'center'
    },
    {
      text: 'Total subsidio',
      value: 'id',
      align: 'center'
    },
    {
      text: 'Subsidio',
      value: 'subsidio',
      align: 'center'
    },
    {
      text: 'Usuario',
      value: 'usuario',
      align: 'center'
    },
    {
      text: 'Detalle',
      value: 'detalle',
      align: 'center'
    },
  ],
  rules: {
    vigencia: [
      v => !!v || 'Este campo es necesario',
    ],
    pleno: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe ser mayor a $ 0,00',
    ],
    subsidio: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe ser mayor a $ 0,00',
    ],
    usuario: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe ser mayor a $ 0,00',
    ],
    detalle: [
      // v => !!v || 'Este campo es necesario',
      // v => v > 0 || 'Debe ser mayor a $ 0,00',
    ],
  },
  options: {
    itemsPerPage: 10,
    page: 1,
    sortBy: [],
    sortDesc: []
  },
  itemsLength: null,
}

// GETTERS
const getters = {
  all (state) {
    return state.all
  },
  edited (state) {
    return state.edited
  },
  selected (state) {
    return state.selected
  },
  filters (state) {
    return state.filters
  },
  rules (state) {
    return state.rules
  },
  headers (state) {
    return state.headers
  },
  itemsLength (state) {
    return state.itemsLength
  },
  options (state) {
    return state.options
  },
  loading (state) {
    return state.loading
  },
  updatable (state) {
    return state.edited.id == state.selected.id && (
      state.edited.vigencia != state.selected.vigencia ||
      state.edited.subsidio != state.selected.subsidio ||
      state.edited.usuario != state.selected.usuario ||
      state.edited.pleno != state.selected.pleno ||
      state.edited.detalle != state.selected.detalle
    )
  },
}

// ACTIONS
const actions = {
  onClearEdited ({ commit }) {
    commit('setEdited', {
      id: null,
      vigencia: null,
      periodo: null,
      pleno: null,
      subsidio: null,
      usuario: null,
      detalle: null,
      created_at: null,
      updated_at: null
    })
  },
  onClearSelected ({ commit }) {
    commit('setSelected', {
      id: null,
      vigencia: null,
      periodo: null,
      pleno: null,
      subsidio: null,
      usuario: null,
      detalle: null,
      created_at: null,
      updated_at: null
    })
  },
  onFetch ({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.get(URL, {
        params: {
          itemsPerPage: state.options.itemsPerPage,
          page: state.options.page,
          sortBy: state.options.sortBy[0],
          sortDesc: state.options.sortDesc[0] ? 1 : 0,
        }
      })
        .then(response => {
          commit('setAll', response.data.data)
          commit('setItemsLength', response.data.meta.total)
          if (state.options.page + state.options.itemsPerPage > response.data.meta.total)
            commit('setPage', 1)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onSave ({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.post(URL, state.edited)
        .then(response => {
          const aux = {
            ...state.edited,
            id: response.data.data.id,
            vigencia: response.data.data.vigencia,
            pleno: response.data.data.pleno,
            subsidio: response.data.data.subsidio,
            usuario: response.data.data.usuario,
            detalle: response.data.data.detalle,
            created_at: response.data.data.created_at,
            updated_at: response.data.data.updated_at
          }
          commit('setEdited', aux)
          commit('setSelected', aux)
          commit('ResponseHTTP/addSuccess', 'El precio fue registrado', { root: true })
          resolve(response.data)
        })
        .catch(error => {
          commit('ResponseHTTP/addError', 'Error al registrar el precio', { root: true })
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onUpdate ({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.put(URL + '/' + state.edited.id, state.edited)
        .then(response => {
          commit('setSelected', state.edited)
          commit('ResponseHTTP/addSuccess', 'El precio fue actualizado.', { root: true })
          resolve(response.data)
        })
        .catch(error => {
          commit('ResponseHTTP/addError', 'Error. No se actualizo el precio', { root: true })
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
}

// MUTATIONS
const mutations = {
  setAll (state, payload) {
    state.all = payload.slice()
  },
  setEdited (state, payload) {
    state.edited = Object.assign({}, payload)
  },
  setSelected (state, payload) {
    state.selected = Object.assign({}, payload)
  },
  setFilters (state, payload) {
    state.filters = Object.assign({}, payload)
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setPage (state, payload) {
    state.options.page = payload
  },
  setItemsPerPage (state, payload) {
    state.options.itemsPerPage = payload
  },
  setItemsLength (state, payload) {
    state.itemsLength = payload
  },
  setOptions (state, payload) {
    state.options = payload
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
